<template>
<div id="page-carga_ds" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>

            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Cargar ZIP Datastage" class="elevation-1 px-5 py-3" >
                   
                    <v-card-text>
                        <v-card-text>
                            <v-form ref="form" lazy-validation>
                                <v-container grid-list-md>
                                    <v-layout wrap>   
                                        <p class="text-justify" v-if="mostrarEncabezados==true" >
                                            <v-icon color="indigo" >info</v-icon>                                            
                                            Verifique que los archivos .asc contengan los encabezados correctos: 
                                                Ver <v-btn small outlined text @click="modalEncabezados=true" >Encabezados de Archivos</v-btn>
                                        </p>                                     
                                        <v-flex xs12>
                                            <v-text-field label="Selecciona el archivo ZIP" @click='pickFile' v-model='name_file' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                            <input type="file" style="display: none" ref="file_input" accept=".zip" @change="onFilePicked" >
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn@click.native="modal=false; reset();" >
                                <v-icon>cancel</v-icon> Cancelar</v-btn>
                                <v-btn v-if="false" color="success" >
                                    <v-icon>done</v-icon>Guardar
                                </v-btn>
                        </v-card-actions>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>

        <!-- MODAL -->
        <v-dialog v-model="modalEncabezados" max-width="80%" style=" z-index: 400 !important;" >
            <v-card>
                <v-card-title>
                    <v-card class="primary white--text titulomodal" >
                        <v-icon @click.native="modalEncabezados = false" class="white--text" >cancel</v-icon>&nbsp;
                        <span class="subheading" >
                            <strong>Encabezados para cada archivo</strong>
                        </span>
                    </v-card>                    
                </v-card-title>
                <v-card-text>
                    <div class="archivoNegrita" >_501.asc</div>
                    <span id ="id501" >Patente|Pedimento|SeccionAduanera|TipoOperacion|ClaveDocumento|SeccionAduaneraEntrada|CurpContribuyente|Rfc|CurpAgenteA|TipoCambio|TotalFletes|TotalSeguros|TotalEmbalajes|TotalIncrementables|TotalDeducibles|PesoBrutoMercancia|MedioTransporteSalida|MedioTransporteArribo|MedioTransporteEntrada_Salida|DestinoMercancia|NombreContribuyente|CalleContribuyente|NumInteriorContribuyente|NumExteriorContribuyente|CPContribuyente|MunicipioContribuyente|EntidadFedContribuyente|PaisContribuyente|TipoPedimento|FechaRecepcionPedimento|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id501')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>
                    
                    <div class="archivoNegrita" >_502.asc</div>
                    <span id="id502" >Patente|Pedimento|SeccionAduanera|RfcTransportista|CurpTransportista|NombreTransportista|PaisTransporte|IdentificadorTransporte|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id502')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_503.asc</div>
                    <span id="id503" >Patente|Pedimento|SeccionAduanera|NumeroGuia|TipoGuia|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id503')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_504.asc</div>
                    <span id="id504" >Patente|Pedimento|SeccionAduanera|NumContenedor|TipoContenedor|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id504')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_505.asc</div>
                    <span id="id505" >Patente|Pedimento|SeccionAduanera|FechaFacturacion|NumeroFactura|TerminoFacturacion|MonedaFacturacion|ValorDolares|ValorMonedaExtranjera|PaisFacturacion|EntidadFedFacturacion|IndentFiscalProveedor|ProveedorMercancia|CalleProveedor|NumInteriorProveedor|NumExteriorProveedor|CpProveedor|MunicipioProveedor|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id505')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_506.asc</div>
                    <span id="id506" >Patente|Pedimento|SeccionAduanera|TipoFecha|FechaOperacion|FechaValidacionPagoR</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id506')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_507.asc</div>
                    <span id="id507" >Patente|Pedimento|SeccionAduanera|ClaveCaso|IdentificadorCaso|TipoPedimento|ComplementoCaso|FechaValidacionPagoR</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id507')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_508.asc</div>
                    <span id="id508" >Patente|Pedimento|SeccionAduanera|InstitucionEmisora|NumeroCuenta|FolioConstancia|FechaConstancia|TipoCuenta|ClaveGarantia|ValorUnitarioTitulo|TotalGarantia|CantidadUnidades|TitulosAsignados|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id508')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_509.asc</div>
                    <span id="id509" >Patente|Pedimento|SeccionAduanera|ClaveContribucion|TasaContribucion|TipoTasa|TipoPedimento|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id509')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_510.asc</div>
                    <span id="id510" >Patente|Pedimento|SeccionAduanera|ClaveContribucion|FormaPago|ImportePago|TipoPedimento|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id510')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_511.asc</div>
                    <span id="id511" >Patente|Pedimento|SeccionAduanera|SecuenciaObservacion|Observaciones|TipoPedimento|FechaValidacionPagoR</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id511')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_512.asc</div>
                    <span id="id512" >Patente|Pedimento|SeccionAduanera|PatenteAduanalOrig|PedimentoOriginal|SeccionAduaneraDespOrig|DocumentoOriginal|FechaOperacionOrig|FraccionOriginal|UnidadMedida|MercanciaDescargada|TipoPedimento|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id512')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_520.asc</div>
                    <span id="id520" >Patente|Pedimento|SeccionAduanera|IndentFiscalDestinatario|NombreDestinatarioMercancia|CalleDestinatario|NumInteriorDestinatario|NumExteriorDestinatario|CpDestinatario|MunicpioDestinatario|PaisDestinatario|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id520')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_551.asc</div>
                    <span id="id551" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|SubdivisionFraccion|DescripcionMercancia|PrecioUnitario|ValorAduana|ValorComercial|ValorDolares|CantidadUMComercial|UnidadMedidaComercial|CantidadUMTarifa|UnidadMedidaTarifa|ValorAgregado|ClaveVinculacion|MetodoValorizacion|CodigoMercanciaProducto|MarcaMercanciaProducto|ModeloMercanciaProducto|PaisOrigenDestino|PaisCompradorVendedor|EntidadFedOrigen|EntidadFedDestino|EntidadFedComprador|EntidadFedVendedor|TipoOperacion|ClaveDocumento|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id551')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_552.asc</div>
                    <span id="id552" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|VinNumeroSerie|KilometrajeVehiculo|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id552')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_553.asc</div>
                    <span id="id553" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClavePermiso|FirmaDescargo|NumeroPermiso|ValorComercialDolares|CantidadMUMTarifa|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id553')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_554.asc</div>
                    <span id="id554" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClaveCaso|IdentificadorCaso|ComplementoCaso|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id554')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_555.asc</div>
                    <span id="id555" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|InstitucionEmisora|NumeroCuenta|FolioConstancia|FechaConstancia|ClaveGarantia|ValorUnitarioTitulo|TotalGarantia|CantidadUnidadesMedida|TitulosAsignados|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id555')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_556.asc</div>
                    <span id="id556" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClaveContribucion|TasaContribucion|TipoTasa|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id556')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_557.asc</div>
                    <span id="id557" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClaveContribucion|FormaPago|ImportePago|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id557')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_558.asc</div>
                    <span id="id558" >Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|SecuenciaObservacion|Observaciones|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id558')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_701.asc</div>
                    <span id="id701" >Patente|Pedimento|SeccionAduanera|ClaveDocumento|FechaPago|PedimentoAnterior|PatenteAnterior|SeccionAduaneraAnterior|DocumentoAnterior|FechaOperacionAnterior|PedimentoOriginal|PatenteAduanalOrig|SeccionAduaneraDespOrig|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id701')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_702.asc</div>
                    <span id="id702" >Patente|Pedimento|SeccionAduanera|ClaveContribucion|FormaPago|ImportePago|TipoPedimento|FechaPagoReal</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('id702')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_Inci.asc</div>
                    <span id="idInci" >Patente|Pedimento|SeccionAduanera|ConsecutivoRemesa|NumeroSeleccion|FechaInicioReconocimiento|HoraInicioReconocimiento|FechaFinReconocimiento|HoraFinReconocimiento|Fraccion|SecuenciaFraccion|ClaveDocumento|TipoOperacion|GradoIncidencia|FechaSeleccion</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('idInci')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_Resumen.asc</div>
                    <span id="idResumen" >Folio|RFCoPatenteAduanal|Fecha_Inicial|Fecha_Final|Fecha_Ejecucion|Total_Fracciones|Total_Contribuciones</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('idResumen')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>

                    <div class="archivoNegrita" >_Sel.asc</div>
                    <span id="idSel" >Patente|Pedimento|SeccionAduanera|ConsecutivoRemesa|NumeroSeleccion|FechaSeleccion|HoraSeleccion|SemaforoFiscal|ClaveDocumento|TipoOperacion</span>
                    &nbsp;<v-btn x-small text color="secondary" @click="copyText('idSel')" title="Copiar al Portapapeles" >
                        <v-icon x-small>file_copy</v-icon>
                    </v-btn><br/><br/>
                    

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="modalEncabezados = false" >
                        <v-icon>cancel</v-icon>Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</div>
</template>

<script>
import axios from "axios";
import JSZip from 'jszip'

export default {
    created: function () {
        this.cliente = this.$local_storage.get("id_cliente");
        //this.model.cliente = 52;  
        
    },
    data() {
        return {
            fab: false,
            mostrarEncabezados: false,
            modalEncabezados: false,
            show_loading: false,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Datastage",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Carga ZIP Datastage",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            update: false,

            file: "",
            cliente: "",
            name_file: "",
            size_file: 0,
            type_file: 'application/zip',
            archivo_original: "",

            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            search: "",

        };
    },

    methods: {
        copyText: function(id) {            
            var el = document.getElementById(id);
            var body = document.body, range, sel;
            if (document.createRange && window.getSelection) {
                range = document.createRange();
                sel = window.getSelection();
                sel.removeAllRanges();
                try {
                    range.selectNodeContents(el);
                    sel.addRange(range);
                } catch (e) {
                    range.selectNode(el);
                    sel.addRange(range);
                }
                document.execCommand("copy");

            } else if (body.createTextRange) {
                range = body.createTextRange();
                range.moveToElementText(el);
                range.select();
                range.execCommand("Copy");
            }                                  
        },
        getCamposLayout: function () {
            axios
                .get(this.$hostname + "catalogos/templates/campos_doc/ ")
                .then(response => {
                    this.camposLayout = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los templates.",
                        footer: ""
                    });
                });
        },
        pickFile() {
            this.$refs.file_input.click()
        },

        onFilePicked(e) {
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                const files = e.target.files;
                var datastage = ["_501", "_502", "_503", "_504", "_505", "_506", "_507", "_508", "_509", "_510", "_511", "_512", "_520", "_551", "_552", "_553", "_554", "_555", "_556", "_557", "_558", "_701", "_702", "_Inci", "_Resumen", "_Sel"];                
                var incorrectos = [];
                if (files[0] !== undefined) {
                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;
                    this.archivo_original = files[0];
                    if (this.name_file.lastIndexOf('.') <= 0) {
                        return false;
                    }
                    var new_zip = new JSZip();
                    var tieneResumen = 0;
                    var thisObj = this;
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])

                    fr.addEventListener('load', () => {
                        this.file = fr.result; // this is an image file that can be sent to server...          
                        var n = this.file.search("base64,");
                        //Para dejar solo el archivo en base 64 y quitar laparte de "text/plain; base64,"
                        if (n >= 0) {
                            this.file = this.file.substring(n + 7);
                        }
                        //console.log(this.file);
                        new_zip.loadAsync(this.file, {
                                base64: true
                            })
                            .then(function (zip) {
                                var folio = '';
                                var rfc = '';
                                var f_inicial = '';
                                var f_final = '';

                                zip.forEach(function (relativePath, file) {
                                    if (relativePath.search("__MACOSX/") == -1) {
                                        //Verificamos que tenga todos los archivos del datastage
                                        for (var k in datastage) {
                                            if (relativePath.search(datastage[k]) != -1)
                                                datastage.splice(k, 1);
                                        }
                                    }
                                });

                                if (datastage.length > 0) {
                                    thisObj.$swal({
                                        type: "error",
                                        title: "¡Operación no Permitida!",
                                        text: "Faltan los archivos " + datastage.join(", ") + " en el ZIP. Favor de verificar.",
                                        footer: ""
                                    });
                                    thisObj.$root.$dialogLoader.hide();
                                    thisObj.reset();
                                } else {
                                    //Recorremos cada archivo para verificar que tenga los encabezados correctos   
                                    var patron= {};
                                    patron["_501"]="Patente|Pedimento|SeccionAduanera|TipoOperacion|ClaveDocumento|SeccionAduaneraEntrada|CurpContribuyente|Rfc|CurpAgenteA|TipoCambio|TotalFletes|TotalSeguros|TotalEmbalajes|TotalIncrementables|TotalDeducibles|PesoBrutoMercancia|MedioTransporteSalida|MedioTransporteArribo|MedioTransporteEntrada_Salida|DestinoMercancia|NombreContribuyente|CalleContribuyente|NumInteriorContribuyente|NumExteriorContribuyente|CPContribuyente|MunicipioContribuyente|EntidadFedContribuyente|PaisContribuyente|TipoPedimento|FechaRecepcionPedimento|FechaPagoReal";
                                    patron["_502"] = "Patente|Pedimento|SeccionAduanera|RfcTransportista|CurpTransportista|NombreTransportista|PaisTransporte|IdentificadorTransporte|FechaPagoReal";
                                    patron["_503"] = "Patente|Pedimento|SeccionAduanera|NumeroGuia|TipoGuia|FechaPagoReal";
                                    patron["_504"] = "Patente|Pedimento|SeccionAduanera|NumContenedor|TipoContenedor|FechaPagoReal";
                                    patron["_505"] = "Patente|Pedimento|SeccionAduanera|FechaFacturacion|NumeroFactura|TerminoFacturacion|MonedaFacturacion|ValorDolares|ValorMonedaExtranjera|PaisFacturacion|EntidadFedFacturacion|IndentFiscalProveedor|ProveedorMercancia|CalleProveedor|NumInteriorProveedor|NumExteriorProveedor|CpProveedor|MunicipioProveedor|FechaPagoReal";
                                    patron["_506"] = "Patente|Pedimento|SeccionAduanera|TipoFecha|FechaOperacion|FechaValidacionPagoR";
                                    patron["_507"] = "Patente|Pedimento|SeccionAduanera|ClaveCaso|IdentificadorCaso|TipoPedimento|ComplementoCaso|FechaValidacionPagoR";
                                    patron["_508"] = "Patente|Pedimento|SeccionAduanera|InstitucionEmisora|NumeroCuenta|FolioConstancia|FechaConstancia|TipoCuenta|ClaveGarantia|ValorUnitarioTitulo|TotalGarantia|CantidadUnidades|TitulosAsignados|FechaPagoReal";
                                    patron["_509"] = "Patente|Pedimento|SeccionAduanera|ClaveContribucion|TasaContribucion|TipoTasa|TipoPedimento|FechaPagoReal";
                                    patron["_510"] = "Patente|Pedimento|SeccionAduanera|ClaveContribucion|FormaPago|ImportePago|TipoPedimento|FechaPagoReal";
                                    patron["_511"] = "Patente|Pedimento|SeccionAduanera|SecuenciaObservacion|Observaciones|TipoPedimento|FechaValidacionPagoR";
                                    patron["_512"] = "Patente|Pedimento|SeccionAduanera|PatenteAduanalOrig|PedimentoOriginal|SeccionAduaneraDespOrig|DocumentoOriginal|FechaOperacionOrig|FraccionOriginal|UnidadMedida|MercanciaDescargada|TipoPedimento|FechaPagoReal";
                                    patron["_520"] = "Patente|Pedimento|SeccionAduanera|IndentFiscalDestinatario|NombreDestinatarioMercancia|CalleDestinatario|NumInteriorDestinatario|NumExteriorDestinatario|CpDestinatario|MunicpioDestinatario|PaisDestinatario|FechaPagoReal";
                                    patron["_551"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|SubdivisionFraccion|DescripcionMercancia|PrecioUnitario|ValorAduana|ValorComercial|ValorDolares|CantidadUMComercial|UnidadMedidaComercial|CantidadUMTarifa|UnidadMedidaTarifa|ValorAgregado|ClaveVinculacion|MetodoValorizacion|CodigoMercanciaProducto|MarcaMercanciaProducto|ModeloMercanciaProducto|PaisOrigenDestino|PaisCompradorVendedor|EntidadFedOrigen|EntidadFedDestino|EntidadFedComprador|EntidadFedVendedor|TipoOperacion|ClaveDocumento|FechaPagoReal";
                                    patron["_552"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|VinNumeroSerie|KilometrajeVehiculo|FechaPagoReal";
                                    patron["_553"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClavePermiso|FirmaDescargo|NumeroPermiso|ValorComercialDolares|CantidadMUMTarifa|FechaPagoReal";
                                    patron["_554"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClaveCaso|IdentificadorCaso|ComplementoCaso|FechaPagoReal";
                                    patron["_555"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|InstitucionEmisora|NumeroCuenta|FolioConstancia|FechaConstancia|ClaveGarantia|ValorUnitarioTitulo|TotalGarantia|CantidadUnidadesMedida|TitulosAsignados|FechaPagoReal";
                                    patron["_556"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClaveContribucion|TasaContribucion|TipoTasa|FechaPagoReal";
                                    patron["_557"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|ClaveContribucion|FormaPago|ImportePago|FechaPagoReal";
                                    patron["_558"] = "Patente|Pedimento|SeccionAduanera|Fraccion|SecuenciaFraccion|SecuenciaObservacion|Observaciones|FechaPagoReal";
                                    patron["_701"] = "Patente|Pedimento|SeccionAduanera|ClaveDocumento|FechaPago|PedimentoAnterior|PatenteAnterior|SeccionAduaneraAnterior|DocumentoAnterior|FechaOperacionAnterior|PedimentoOriginal|PatenteAduanalOrig|SeccionAduaneraDespOrig|FechaPagoReal";
                                    patron["_702"] = "Patente|Pedimento|SeccionAduanera|ClaveContribucion|FormaPago|ImportePago|TipoPedimento|FechaPagoReal";
                                    patron["_Inci"] = "Patente|Pedimento|SeccionAduanera|ConsecutivoRemesa|NumeroSeleccion|FechaInicioReconocimiento|HoraInicioReconocimiento|FechaFinReconocimiento|HoraFinReconocimiento|Fraccion|SecuenciaFraccion|ClaveDocumento|TipoOperacion|GradoIncidencia|FechaSeleccion";
                                    patron["_Resumen"] = "Folio|RFCoPatenteAduanal|Fecha_Inicial|Fecha_Final|Fecha_Ejecucion|Total_Fracciones|Total_Contribuciones";                                    
                                    patron["_Sel"] = "Patente|Pedimento|SeccionAduanera|ConsecutivoRemesa|NumeroSeleccion|FechaSeleccion|HoraSeleccion|SemaforoFiscal|ClaveDocumento|TipoOperacion";

                                    //JEMM(21-07-2022): Jumberto solicitó que los encabezados no importe si es mayusculas o minusculas
                                    var dataResumen = "";
                                    var folio = "";
                                    var rfc = "";
                                    var f_inicial = "";
                                    var f_final = "";
                                    var totalLeidos = [];   
                                    var datastage2 = ["_501", "_502", "_503", "_504", "_505", "_506", "_507", "_508", "_509", "_510", "_511", "_512", "_520", "_551", "_552", "_553", "_554", "_555", "_556", "_557", "_558", "_701", "_702", "_Inci", "_Resumen", "_Sel"];                                 
                                    zip.forEach(function (relativePath, file) {
                                        if (relativePath.search("__MACOSX/") == -1){                                            
                                            file.async('text').then(function (content) {                                                    
                                                if (relativePath.search(".asc") != -1) { 
                                                    var splitRelative = relativePath.split("/");                                                    
                                                    if(splitRelative.length>0){                                                        
                                                        var nombreArchivo = splitRelative[splitRelative.length-1];
                                                        var content_lower = content.toString().toLowerCase();
                                                        for(var keyD in datastage2){                                                                                                               
                                                            if (nombreArchivo.search(datastage2[keyD]) != -1) { 
                                                                if (totalLeidos.findIndex(function(l){return l== datastage2[keyD]})== -1)
                                                                    totalLeidos.push(datastage2[keyD]);                                                      
                                                                if (content_lower.indexOf(patron[datastage2[keyD]].toString().toLowerCase()) == -1){
                                                                    incorrectos.push(nombreArchivo);
                                                                }                                 
                                                                if (datastage2[keyD]=="_Resumen" && incorrectos.findIndex(function(i){return i==nombreArchivo}) == -1) {                                                                
                                                                    dataResumen = content.split("|");
                                                                    folio = dataResumen[6].replace("Total_Contribuciones", "").replace(" ", "").replace(/(\r\n|\n|\r)/gm, "");
                                                                    rfc = dataResumen[7];
                                                                    f_inicial = dataResumen[8];
                                                                    f_final = dataResumen[9];                                                    
                                                                }
                                                            }    
                                                        }
                                                    }
                                                    
                                                }                                              
                                                
                                                if (totalLeidos.length == 26){                                                       
                                                    thisObj.$root.$dialogLoader.hide();                                         
                                                    if (incorrectos.length > 0){
                                                        thisObj.$swal({
                                                            type: "error",
                                                            title: "Encabezados Incorrectos",
                                                            text: "Archivos con encabezados incorrectos. Favor de verificar.",
                                                            footer: "Incorrectos: "+incorrectos.join(", ")
                                                        });                                                        
                                                        thisObj.mostrarEncabezados = true;
                                                        thisObj.reset();
                                                    } else {                                                        
                                                        thisObj.verificaResumen(folio, rfc, f_inicial, f_final);
                                                    }
                                                    
                                                } 
                                            });
                                        }  
                                        
                                                                             
                                    });
                                    
                                    
                                    
                                }

                            });
                    });

                }
            } catch (error) {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.$root.$dialogLoader.hide();
                this.reset();
            }

        },

        verificaResumen: function (folio, rfc, f_inicial, f_final) {
            var rfcActual = this.$local_storage.get("rfc");
            var usuario = this.$local_storage.get("id_usuario");
            var anio_inicial = f_inicial.substring(0, 4);
            var mes_inicial = f_inicial.substring(5, 7);
            var anio_final = f_final.substring(0, 4);
            var mes_final = f_final.substring(5, 7);

            if (f_inicial.length != 10 || f_final.length != 10) {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Las fechas del ZIP: " + f_inicial + " o " + f_final + " no tienen el formato AAAA-MM-DD. Favor de verificar.",
                    footer: ""
                });
                this.reset();

            } else if (rfcActual.toString().trim().toLowerCase() == rfc.toString().trim().toLowerCase()) {

                this.$swal({
                    type: "info",
                    title: "Cuidado",
                    text: "¿Está seguro de cargar el archivo con Folio:"+folio+" y con fechas: "+f_inicial+" a "+f_final+"?",
                    footer: "",
                    showCancelButton: true,
                    cancelButtonColor: "#d33",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Cancelar"
                }).then(result => {
                    if (result.value) {
                        let datos = {
                            rfc: rfc,
                            size: this.size_file,
                            folio: folio,
                            usuario_id: usuario,
                            fecha_inicial: f_inicial,
                            fecha_final: f_final,
                            anio_inicial: anio_inicial,
                            mes_inicial: mes_inicial,
                            anio_final: anio_final,
                            mes_final: mes_final,
                        };

                        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                        var thisObj = this;
                        axios.post(this.$hostname + "datastage/guardar_bitacora/", datos)
                            .then(response => {                                
                                thisObj.guardarZip(rfcActual, folio, f_inicial, f_final, thisObj.file);                                                                    
                            })
                            .catch(error => {
                                var mostrarNotificacion = 1;
                                var mensaje = 'Ocurrió un error al cargar el archivo ZIP';
                                var footer = '';
                                if (error.response != undefined && error.response.data != undefined) {
                                    if (error.response.data.mensaje != undefined && error.response.data.mensaje == 'Periodo existente'){
                                        mensaje = 'El folio:'+folio+' y las fechas: ' + f_inicial + ' a ' + f_final + ' del RFC: ' + rfcActual + ' ya aparece como registrado. ¿Desea guardarlo de todos modos?';
                                        mostrarNotificacion = 0;

                                        thisObj.$swal({
                                            type: "info",
                                            title: "Aviso",
                                            text: mensaje,
                                            footer: "IMPORTANTE: La información será substituída, no se duplicará.",
                                            showCancelButton: true,
                                            cancelButtonColor: "#d33",
                                            confirmButtonColor: "#3085d6",
                                            confirmButtonText: "Aceptar",
                                            cancelButtonText: "Cancelar"
                                        }).then(result => {
                                            if (result.value) {
                                                 thisObj.guardarZip(rfcActual, folio, f_inicial, f_final, thisObj.file);
                                            } else {
                                                thisObj.$root.$dialogLoader.hide();
                                                thisObj.reset();
                                            }
                                        });

                                    }else if (error.response.data.mensaje != undefined)
                                        footer = error.response.data.mensaje;
                                    else if (error.response.data != undefined) {
                                        for (var k in error.response.data) {
                                            footer += k + ": " + error.response.data[k][0];
                                        }

                                    }

                                }
                                if (mostrarNotificacion == 1){
                                    this.$swal({
                                        type: "error",
                                        title: "¡Operación no Permitida!",
                                        text: mensaje,
                                        footer: footer,
                                    });
                                    this.$root.$dialogLoader.hide();
                                    this.reset();
                                }
                                
                            });
                    } else {
                        this.reset();
                    }
                });
            } else {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "El RFC del ZIP: " + rfc + " no coincide con el RFC de la sesión actual " + rfcActual + ". Favor de verificar.",
                    footer: ""
                });
                this.reset();
            }

        },

        guardarZip: function(rfcActual, folio, f_inicial, f_final, fileZIP, intento=1){
            var keyBucket = rfcActual.toString().trim().toUpperCase() + "/glosas/" + rfcActual.toString().trim().toUpperCase() + "-" + folio.toString().trim() + "_" + f_inicial.toString().trim() + "_" + f_final.toString().trim() + ".zip";
            var zipfilekey = rfcActual.toString().trim().toUpperCase() + "-" + folio.toString().trim() + "_" + f_inicial.toString().trim() + "_" + f_final.toString().trim() + ".zip";
            //console.log("Intento:",intento);
                    
            var datos = {
                key: keyBucket,
                bucket: "production.econnect.ds",
                type: this.type_file
            }
            var thisObj = this;
            axios.post(this.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, thisObj.archivo_original, {headers:{'Content-Type': thisObj.type_file}})
                        .then((res) => {
                            let formData = {                                
                                key: keyBucket,
                                usuario: thisObj.$local_storage.get("id_usuario"),                                
                            };
                            axios.post(thisObj.$apiVucem + 'datastage/guardar_glosa/', formData)
                            .then((res) => {                                
                                thisObj.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "El archivo ZIP se ha cargado correctamente.",
                                    footer: ""
                                });                                
                            }).catch((error) => {//ya que si el archivo es muy grande recibirá un timeOut, igualmente recibirá notificación al terminar de cargarse
                                thisObj.$swal({
                                    type: "info",
                                    title: "Operación En Proceso",
                                    text: "El archivo ZIP es válido y se está procesando. Recibirá una notificación cuando la información se haya cargado.",
                                    footer: ""
                                });
                            }).then(() => {
                                thisObj.$root.$dialogLoader.hide()
                                thisObj.reset();
                            });
                        }).catch((error)=>{
                            if(intento >= 3){
                                thisObj.$root.$dialogLoader.hide();
                                thisObj.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.",
                                    footer: '',
                                });
                                //SI NO SE PUDO CARGAR A S3, SE ELIMINA EL REGISTRO DE LA GLOSA                    
                                thisObj.eliminaBitacora(zipfilekey);
                                console.log(error);
                            } else {
                                thisObj.guardarZip(rfcActual, folio, f_inicial, f_final, fileZIP, intento+1)
                            }
                            
                        });
                        
                    } else {
                        if(intento >= 3){
                            thisObj.$root.$dialogLoader.hide();
                            thisObj.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.",
                                footer: '',
                            });
                            //SI NO SE PUDO CARGAR A S3, SE ELIMINA EL REGISTRO DE LA GLOSA                    
                            thisObj.eliminaBitacora(zipfilekey);
                        } else {
                            thisObj.guardarZip(rfcActual, folio, f_inicial, f_final, fileZIP, intento+1)
                        }                        
                    }
                })
                .catch((error) => {
                    if(intento >= 3){
                        var mensaje = "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.";
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                            mensaje = error.response.data.mensaje;
                        thisObj.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);
                        //SI NO SE PUDO CARGAR A S3, SE ELIMINA EL REGISTRO DE LA GLOSA                    
                        thisObj.eliminaBitacora(zipfilekey);
                        thisObj.$root.$dialogLoader.hide();
                    } else {
                        thisObj.guardarZip(rfcActual, folio, f_inicial, f_final, fileZIP, intento+1)
                    }                    
                });

        },

        eliminaBitacora: function(zipfilekey){
            axios.post(this.$hostname + "datastage/eliminar_bitacora/", {
                "nombre_glosa": zipfilekey
            })
            .then(response => {}).catch((err) => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al eliminar el registro de la glosa.",
                    footer: '',
                });
            });
        },

        reset() {
            const input = this.$refs.file_input;
            input.type = 'text';
            input.type = 'file';
            this.name_file = '';
            this.archivo_original = '';
        },
    }
};
</script>
<style scoped>
.archivoNegrita {
  color: black !important;
  font-weight: bold !important;
  font-size: 15px;
}
</style>